<template>

   <div  class="grid mb-3 adicionar-carrinho-cores">
      
      <div v-for="c of displayCores" :key="c.id" :class="(c.isSelecionado)?'adicionar-carrinho-cor selecionada':'adicionar-carrinho-cor'" @click="c.isSelecionado = $utils.getStdObject(!c.isSelecionado), this.$emit('selecionados', this.displayCores.filter(c => c.isSelecionado))" :style="{ backgroundColor: c.isSelecionado ? '#f0f0f0' : 'transparent' }">
        <Image :src="c.foto1" :alt="c.nome" class="adicionar-carrinho-cor-image overflow-hidden border-circle block" style="--aspect-ratio: 1/1" imageClass="max-w-full h-auto block" />
        <div class="adicionar-carrinho-cor-nome text-sm text-center">
            {{ c.nome.length > 6 ? c.nome.slice(0, 6) + '...' : c.nome }}
        </div>
      </div>
    <div class="col-12" style="text-align: right;">
      <label v-if="displayCores.length < cores.length" @click="vermais" style="cursor:pointer;">
        ver mais...
      </label>
    </div>
    </div>

</template>

<script>

export default {
    name: "PrecoFiltro",
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    emits: [
        'selecionados'
    ],
    data: function () {
        return {

            cores: [],
            displayCores:[]

        }
    },
    // mounted() {
    //     if (this.value.length > 0) {
    //         this.cores = this.$utils.getStdObject(this.value);
    //         //this.displayCores = this.value.slice(0, 3);
    //         this.displayCores.push(...this.cores.slice(this.displayCores.length, this.displayCores.length + 3));
    //     }
    // },
     watch: {
        value: {
            handler(newValue) {
              console.log('CoresFiltro value changed:', newValue);
                 this.cores = this.$utils.getStdObject(newValue);
                this.displayCores = this.$utils.getStdObject(newValue).slice(0, 3);
                 //this.displayCores = []
                //this.displayCores.push(...this.cores.slice(this.displayCores.length, this.displayCores.length + 3));
            },
            deep: true
        }
      },
    methods: {
        vermais() {
           const novos = this.cores.slice(this.displayCores.length, this.displayCores.length + 3).map(c => ({ ...c }));
          this.displayCores.push(...novos);
        }
    },
   
}
</script>

<style lang="scss">
.adicionar-carrinho-cores, .adicionar-carrinho-tamanhos {
  max-width: 445px;
}

.adicionar-carrinho-cor, .adicionar-carrinho-tamanho {
  padding: 0.5rem;
  cursor: pointer;
}

.adicionar-carrinho-cor-image {
  width: 45px;
  margin: 0 auto;
}

.adicionar-carrinho-tamanho span {
  background: #dddddd;
  border-radius: 4px;
}

.adicionar-carrinho-tamanho.selecionado span {
  background: var(--primaryBackgroundColor, $primaryBackgroundColor);
  color: white;
}

.adicionar-carrinho-cor.selecionada .adicionar-carrinho-cor-image {
  border: 3px solid var(--primaryBackgroundColor, $primaryBackgroundColor);
}
</style>